import Vue from "vue";
import Vuex from "vuex";
import navigation from "@/store/modules/navigation";
import organizations from "@/store/modules/coreIAM/organizations";
import scopes from "@/store/modules/coreIAM/scopes";
import roles from "@/store/modules/coreIAM/roles";
import apis from "@/store/modules/coreIAM/apis";
import fronts from "@/store/modules/coreIAM/fronts";
import serviceAccounts from "@/store/modules/coreIAM/serviceAccounts";
import users from "@/store/modules/coreIAM/users";
import profile from "@/store/modules/coreIAM/profile";
import locations from "@/store/modules/kitchens/locations";
import concepts from "@/store/modules/kitchens/concepts";
import kitchens from "@/store/modules/kitchens/kitchens";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    navigation,
    organizations,
    scopes,
    roles,
    apis,
    fronts,
    serviceAccounts,
    locations,
    concepts,
    kitchens,
    users,
    profile,
  },
});
